// extracted by mini-css-extract-plugin
export default {"display":"aPQdRm","device":"KhnDuB","speaker":"oEUMCt","phone":"wT06qm","sidebarVisible":"WKe4zp"};